import { useState } from 'react';

const TechnologiesSection = () => {
  const categories = ['Front-End', 'Back-End', 'Mobile', 'Database', 'DevOps'];
  const [activeCategory, setActiveCategory] = useState(0);

  const techData = [
    {
      category: 'Front-End',
      description: 'Modern, responsive interfaces built with cutting-edge frameworks that deliver exceptional user experiences across all devices.',
      stat: { value: '14', label: 'Frameworks', detail: 'React, Vue, Angular, Svelte & more' },
      techs: [
        { name: 'HTML5', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg' },
        { name: 'CSS3', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original.svg' },
        { name: 'JavaScript', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg' },
        { name: 'Vue.js', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/vuejs/vuejs-original.svg' },
        { name: 'React', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg' },
        { name: 'Angular', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/angularjs/angularjs-original.svg' },
        { name: 'TypeScript', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/typescript/typescript-original.svg' },
        { name: 'D3.js', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/d3js/d3js-original.svg' },
      ],
    },
    {
      category: 'Back-End',
      description: 'Scalable server-side architecture powering high-performance applications with robust APIs and microservices.',
      stat: { value: '12', label: 'Platforms', detail: 'Node.js, Python, Go, Java & more' },
      techs: [
        { name: 'Node.js', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg' },
        { name: 'Python', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original.svg' },
        { name: 'GraphQL', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/graphql/graphql-plain.svg' },
        { name: 'PHP', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/php/php-original.svg' },
        { name: 'Java', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/java/java-original.svg' },
        { name: 'Go', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/go/go-original.svg' },
        { name: 'Ruby', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/ruby/ruby-original.svg' },
        { name: 'C#', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/csharp/csharp-original.svg' },
      ],
    },
    {
      category: 'Mobile',
      description: 'Native and cross-platform mobile applications that deliver seamless experiences on iOS and Android devices.',
      stat: { value: '6', label: 'Platforms', detail: 'iOS, Android, Flutter, React Native' },
      techs: [
        { name: 'Swift', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/swift/swift-original.svg' },
        { name: 'Kotlin', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/kotlin/kotlin-original.svg' },
        { name: 'Flutter', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/flutter/flutter-original.svg' },
        { name: 'React Native', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg' },
        { name: 'Dart', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/dart/dart-original.svg' },
        { name: 'Firebase', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/firebase/firebase-plain.svg' },
        { name: 'Android', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/android/android-original.svg' },
        { name: 'iOS', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/apple/apple-original.svg' },
      ],
    },
    {
      category: 'Database',
      description: 'Relational and NoSQL database solutions optimized for performance, scalability, and data integrity.',
      stat: { value: '8', label: 'Engines', detail: 'PostgreSQL, MongoDB, Redis & more' },
      techs: [
        { name: 'PostgreSQL', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/postgresql/postgresql-original.svg' },
        { name: 'MongoDB', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg' },
        { name: 'MySQL', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mysql/mysql-original.svg' },
        { name: 'Redis', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/redis/redis-original.svg' },
        { name: 'SQLite', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/sqlite/sqlite-original.svg' },
        { name: 'Elasticsearch', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/elasticsearch/elasticsearch-original.svg' },
        { name: 'Cassandra', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/cassandra/cassandra-original.svg' },
        { name: 'DynamoDB', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/dynamodb/dynamodb-original.svg' },
      ],
    },
    {
      category: 'DevOps',
      description: 'Automated infrastructure, CI/CD pipelines, and cloud-native deployment strategies for modern teams.',
      stat: { value: '10', label: 'Tools', detail: 'Docker, Kubernetes, Terraform & more' },
      techs: [
        { name: 'Docker', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/docker/docker-original.svg' },
        { name: 'Kubernetes', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/kubernetes/kubernetes-plain.svg' },
        { name: 'AWS', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/amazonwebservices/amazonwebservices-original-wordmark.svg' },
        { name: 'Terraform', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/terraform/terraform-original.svg' },
        { name: 'Jenkins', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/jenkins/jenkins-original.svg' },
        { name: 'GitHub', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/github/github-original.svg' },
        { name: 'GitLab', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/gitlab/gitlab-original.svg' },
        { name: 'Azure', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/azure/azure-original.svg' },
      ],
    },
  ];

  const current = techData[activeCategory];

  return (
    <section id="technologies" className="relative w-full bg-foreground-900 text-background-50 py-14 md:py-16 overflow-hidden">
      <div className="absolute inset-0 opacity-[0.06] pointer-events-none">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle, oklch(var(--background-50)) 1px, transparent 1px)',
          backgroundSize: '32px 32px'
        }}></div>
      </div>

      <div className="relative section-padding">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12 md:mb-16">
            <div>
              <div className="flex items-center gap-3 mb-4">
                <span className="inline-flex w-6 h-6 items-center justify-center bg-primary-500 text-background-50 rounded-sm">
                  <i className="ri-cpu-line text-xs"></i>
                </span>
                <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-background-400">
                  03 / Our Stack
                </span>
              </div>
              <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold leading-[1.02] tracking-tight max-w-3xl">
                The technologies that{' '}
                <span className="block text-primary-500">never compromise.</span>
              </h2>
            </div>
            <p className="max-w-md text-[15px] leading-relaxed text-background-300">
              We master the tools that power the modern web — from frontend frameworks to cloud infrastructure.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-8">
            {/* Category Tabs */}
            <div className="lg:col-span-3 flex flex-col gap-2">
              {categories.map((category, index) => (
                <button
                  key={index}
                  onClick={() => setActiveCategory(index)}
                  className={`group relative text-left p-4 rounded-xl border transition-all cursor-pointer overflow-hidden ${
                    activeCategory === index
                      ? 'bg-background-50 text-foreground-900 border-background-50'
                      : 'bg-background-50/[0.04] text-background-50 border-background-50/15 hover:bg-background-50/[0.08]'
                  }`}
                >
                  {activeCategory === index && (
                    <span className="absolute left-0 bottom-0 h-[3px] bg-primary-500 transition-[width] ease-linear w-full"></span>
                  )}
                  <div className="flex items-center justify-between mb-1">
                    <span className={`font-mono text-[10px] uppercase tracking-widest ${activeCategory === index ? 'text-foreground-500' : 'text-background-400'}`}>
                      Stack {String(index + 1).padStart(2, '0')}
                    </span>
                    <i className={`ri-arrow-right-line text-lg transition-transform ${activeCategory === index ? 'translate-x-1 text-primary-500' : 'group-hover:translate-x-1'}`}></i>
                  </div>
                  <div className="font-display text-lg font-bold">{category}</div>
                </button>
              ))}
            </div>

            {/* Content Panel */}
            <div className="lg:col-span-9">
              <div className="relative bg-background-50 text-foreground-900 rounded-2xl overflow-hidden">
                <div className="p-7 md:p-9">
                  <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-6 mb-8">
                    <div className="md:max-w-lg">
                      <h3 className="font-display text-2xl md:text-3xl font-bold leading-tight mb-3">
                        {current.category} Stack
                      </h3>
                      <p className="text-[15px] leading-relaxed text-foreground-700">
                        {current.description}
                      </p>
                    </div>
                    <div className="md:pl-7 md:border-l md:border-background-200">
                      <div className="font-mono text-[10px] uppercase tracking-widest text-foreground-500 mb-2">
                        {current.stat.label}
                      </div>
                      <div className="font-display text-4xl font-bold text-primary-500 leading-none tabular-nums">
                        {current.stat.value}
                      </div>
                      <div className="mt-4 text-xs text-foreground-500 leading-relaxed">
                        {current.stat.detail}
                      </div>
                    </div>
                  </div>

                  <div className="grid grid-cols-4 sm:grid-cols-8 gap-4">
                    {current.techs.map((tech, i) => (
                      <div
                        key={i}
                        className="flex flex-col items-center gap-2 p-3 bg-background-100 rounded-xl border border-background-200 hover:border-primary-500/40 transition-all group"
                      >
                        <img
                          alt={tech.name}
                          className="w-10 h-10 object-contain filter grayscale group-hover:grayscale-0 transition-all"
                          src={tech.icon}
                        />
                        <span className="text-foreground-500 text-[10px] font-medium text-center leading-tight">
                          {tech.name}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TechnologiesSection;